/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ListResourceRecommendationRequest {
    getFixupPrototypeFunction() { return ListResourceRecommendationRequest.fixupPrototype; }

    static newInstance(model: Partial<ListResourceRecommendationRequest>): ListResourceRecommendationRequest {
        let obj = Object.assign(new ListResourceRecommendationRequest(), model);
        ListResourceRecommendationRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ListResourceRecommendationRequest>): ListResourceRecommendationRequest {
        if (!model) return null;
        return ListResourceRecommendationRequest.newInstance(<ListResourceRecommendationRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ListResourceRecommendationRequest) {
        if (!obj) return;

        models.ListResourceRecommendationRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ListResourceRecommendationRequest): boolean {
        Object.setPrototypeOf(obj, ListResourceRecommendationRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.list_context) {
            models.ListContext.fixupPrototype(this.list_context);
        }
        if (this.filters) {
            models.ListResourceRecommendationFilters.fixupPrototype(this.filters);
        }
        if (this.sort) {
            for (let val of this.sort) {
                models.ResourceRecommendationsSortCriteria.fixupPrototype(val);
            }
        }
    }

    /**
     * Optional list context
     */
    list_context: models.ListContext;

    /**
     * Sort criteria
     */
    sort: Array<models.ResourceRecommendationsSortCriteria>;

    /**
     * Filters for the request
     */
    filters: models.ListResourceRecommendationFilters;

}
